import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import appAction from '../redux/actions/app';
import {
  acceptCurrentViewportAsBaseline,
  isCalibrationRoute,
  isPatientZoomWarningRoute,
  useWindowZoom,
} from '../tools';
import { stateType } from '../types/types';

// Dispatches the viewport-zoom warning for patient exam-prep routes.
export const usePatientZoomWarningNotification = (pathname: string): void => {
  const dispatch = useDispatch();
  const windowZoom = useWindowZoom();
  const userType = useSelector((state: stateType) => state.user.user.userType);

  // On calibration: accept zoom on enter and on leave so changes made there do not warn on the next step.
  useEffect(() => {
    if (!isCalibrationRoute(pathname)) {
      return;
    }

    acceptCurrentViewportAsBaseline();

    return () => {
      acceptCurrentViewportAsBaseline();
    };
  }, [pathname]);

  useEffect(() => {
    const showZoomWarning = userType === 'patient' && isPatientZoomWarningRoute(pathname) && windowZoom;

    dispatch(appAction.appNotification(showZoomWarning));

    return () => {
      dispatch(appAction.appNotification(false));
    };
  }, [dispatch, pathname, userType, windowZoom]);
};
